<div>
  @if (data.title) {
    <mat-toolbar>{{ data.title }}</mat-toolbar>
  }
  <mat-dialog-content class="text-center">
    <p>{{ data.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="gap-2 mt-2">
    <button mat-flat-button (click)="onCancel()">{{ data.cancelText }}</button>
    <button mat-flat-button color="warn" (click)="onConfirm()">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
